module.exports = __webpack_public_path__ + "images/landing_get_it_from_apple.c7d1d5c41ea93d50b9b07136066c875d.png";